import { render, staticRenderFns } from "./NotificacionesList.vue?vue&type=template&id=2b8eaa5d&"
import script from "./NotificacionesList.vue?vue&type=script&lang=js&"
export * from "./NotificacionesList.vue?vue&type=script&lang=js&"
import style0 from "./NotificacionesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports